var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("div", { staticClass: "search_criteria" }, [
        _c(
          "div",
          [
            _c("el-input", {
              attrs: { placeholder: "名称查询", clearable: "" },
              model: {
                value: _vm.queryData.fileName,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "fileName", $$v)
                },
                expression: "queryData.fileName",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { margin: "0 10px" } },
          [
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  clearable: "",
                  placeholder: "请选择模块",
                },
                on: { change: _vm.search },
                model: {
                  value: _vm.queryData.modeCode,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "modeCode", $$v)
                  },
                  expression: "queryData.modeCode",
                },
              },
              _vm._l(_vm.moduleData, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { label: item.title, value: item.id },
                })
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "el-select",
              {
                attrs: {
                  filterable: "",
                  clearable: "",
                  placeholder: "请选择状态",
                },
                on: { change: _vm.search },
                model: {
                  value: _vm.queryData.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "status", $$v)
                  },
                  expression: "queryData.status",
                },
              },
              [
                _c("el-option", { attrs: { value: 1, label: "启用" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 0, label: "禁用" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex",
            staticStyle: { width: "fit-content", "margin-left": "10px" },
          },
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.search } },
              [_vm._v("查询")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "ml10",
                attrs: { type: "info", plain: "" },
                on: { click: _vm.rest },
              },
              [_vm._v("重置")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", plain: "" },
                on: { click: _vm.onAddContent },
              },
              [_vm._v("新增内容")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "warning", plain: "" },
                on: { click: _vm.onModuleManage },
              },
              [_vm._v("模块管理")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt10" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "mainUrl",
                  label: "主图",
                  width: "180",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("img", {
                          staticStyle: {
                            width: "50px",
                            height: "50px",
                            "border-radius": "8px",
                          },
                          attrs: { src: scope.row.mainUrl, alt: "" },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "fileName", label: "名称", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "fc" }, [
                          _c("div", { staticClass: "nickname_style" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.fileName) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "modeCode", label: "所属模块", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "fc" }, [
                          _c("div", { staticClass: "nickname_style" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.moduleData.find(function (item) {
                                    return (
                                      Number(item.id) ===
                                      Number(scope.row.modeCode)
                                    )
                                  }).title
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sortNo", label: "模块内排序", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "fc" }, [
                          _c("div", { staticClass: "nickname_style" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.sortNo) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "创建时间",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "fc" }, [
                          _c("div", { staticClass: "nickname_style" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(scope.row.updateTime) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "fc" }, [
                          _c("div", { staticClass: "nickname_style" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  scope.row.status === 1 ? "启用" : "禁用"
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "操作", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "fc" }, [
                          _c(
                            "div",
                            {
                              staticClass: "Operation_button",
                              on: {
                                click: function ($event) {
                                  return _vm.onEditor(scope.row)
                                },
                              },
                            },
                            [_vm._v("\n              编辑\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "Operation_button1 ml10",
                              on: {
                                click: function ($event) {
                                  return _vm.onDel(scope.row)
                                },
                              },
                            },
                            [_vm._v("\n              删除\n            ")]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt20 page_box" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.queryData.page.page,
              "page-sizes": [10, 20, 30, 40],
              "page-size": _vm.queryData.page.size,
              layout: "total, prev, pager, next, sizes,jumper",
              total: _vm.total,
              background: "",
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            title: "内容" + (_vm.ControlsType == "add" ? "新增" : "编辑"),
            width: "750px",
            top: "10vh",
            "custom-class": "dialog_box",
          },
          on: { close: _vm.onClose },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "新手教程图", prop: "mainUrl" } },
                [
                  _c(
                    "div",
                    { staticClass: "frb" },
                    [
                      _c(
                        "upload",
                        {
                          attrs: {
                            name: "mainUrl",
                            "img-url": _vm.ruleForm.mainUrl,
                            width: "160px",
                            height: "104px",
                          },
                          on: {
                            pictureAddress: function ($event) {
                              return _vm.onPictureAddress($event)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#f59a23",
                                "font-size": "12px",
                              },
                            },
                            [_vm._v("建议尺寸不超过162px*104px，PNG格式")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "内容名称", prop: "fileName" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.ruleForm.fileName,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "fileName", $$v)
                      },
                      expression: "ruleForm.fileName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "所属模块", prop: "modeCode" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { filterable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.ruleForm.modeCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "modeCode", $$v)
                        },
                        expression: "ruleForm.modeCode",
                      },
                    },
                    _vm._l(_vm.moduleData, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.title, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sortNo" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.ruleForm.sortNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "sortNo", $$v)
                      },
                      expression: "ruleForm.sortNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "上传视频", prop: "fileUrl" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "",
                        "http-request": _vm.handleFileUpload,
                        "on-remove": _vm.handleRemove,
                        "file-list": _vm.fileList,
                        "on-change": _vm.handleChange,
                        accept: "video/mp4",
                      },
                    },
                    [
                      _vm.uploadStatus
                        ? _c(
                            "el-button",
                            { attrs: { size: "small", type: "primary" } },
                            [_vm._v("点击上传 ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.uploadStatus
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                color: "#fff",
                                "background-color": "#409eff",
                                "border-color": "#409eff",
                                "font-size": "12px",
                                "border-radius": "3px",
                                padding: "0 20px",
                              },
                            },
                            [
                              _vm._v("\n            上传中\n            "),
                              _c("img", {
                                staticStyle: { width: "10px", height: "10px" },
                                attrs: {
                                  src: require("@/assets/beginnerCoures/loading.gif"),
                                  alt: "",
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [
                          _vm._v("仅支持MP4格式且编码方式为("),
                          _c(
                            "txt",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "600",
                                "font-size": "14px",
                              },
                            },
                            [_vm._v("H.264")]
                          ),
                          _vm._v(")的视频文件"),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.fileUrl
                    ? _c("video", {
                        staticClass: "preview-player",
                        attrs: { src: _vm.ruleForm.fileUrl, controls: "" },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.ruleForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "status", $$v)
                        },
                        expression: "ruleForm.status",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("启用")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("禁用")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("确认")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.resetForm("ruleForm")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.moduleManage,
            "close-on-click-modal": false,
            title: "模块管理",
            width: "1050px",
            top: "10vh",
            "custom-class": "dialog_box",
          },
          on: { close: _vm.onModuleClose },
        },
        [
          _c("div", { staticClass: "fc" }, [
            _c("div", [
              _c(
                "div",
                { staticClass: "module_box" },
                [
                  _c("div", { staticClass: "flex" }, [
                    _c("div", { staticClass: "title1 w1" }, [
                      _vm._v("模块标题"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "title1 w2" }, [
                      _vm._v("标题文字色"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "title1 w3" }, [
                      _vm._v("模块背景色"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "w4" }),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.moduleData, function (item, index) {
                    return _c(
                      "div",
                      { key: item.id, staticClass: "flex mt20" },
                      [
                        _c(
                          "div",
                          { staticClass: "w1" },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入模块标题" },
                              model: {
                                value: item.title,
                                callback: function ($$v) {
                                  _vm.$set(item, "title", $$v)
                                },
                                expression: "item.title",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w2" },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "设置标题文字色" },
                              model: {
                                value: item.textColor,
                                callback: function ($$v) {
                                  _vm.$set(item, "textColor", $$v)
                                },
                                expression: "item.textColor",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w3" },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "设置模块背景色" },
                              model: {
                                value: item.bgColor,
                                callback: function ($$v) {
                                  _vm.$set(item, "bgColor", $$v)
                                },
                                expression: "item.bgColor",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "w4" }, [
                          _c(
                            "span",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.onDelModule(index)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                删除\n                "
                              ),
                              _c("img", {
                                staticStyle: { width: "15px", height: "15px" },
                                attrs: {
                                  src: require("@/assets/beginnerCoures/del.png"),
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-top": "40px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onModuleVerify },
                    },
                    [_vm._v("保存")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.onAddModule },
                    },
                    [_vm._v("新增模块")]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }